import React, { useEffect, useMemo, useState } from 'react';
import { listarCatalogoMotosPublico } from '../../api/catalogoMotosPublico';
import './CatalogoMotos.css';

export default function CatalogoMotos() {
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [marca, setMarca]     = useState('TODAS');
  const [categoria, setCategoria] = useState('TODAS');
  const [busqueda, setBusqueda]   = useState('');

  useEffect(() => {
    document.title = 'AITA - Catálogo de Motos';
    cargar();
  }, []);

  const cargar = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await listarCatalogoMotosPublico();
      setItems(data);
    } catch {
      setError('No se pudieron cargar las motos disponibles.');
    } finally {
      setLoading(false);
    }
  };

  const categorias = useMemo(() => {
    const set = new Set(items.map(i => i.categoria).filter(Boolean));
    return ['TODAS', ...Array.from(set).sort()];
  }, [items]);

  const lista = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    return items.filter(i => {
      if (marca !== 'TODAS' && i.marca !== marca) return false;
      if (categoria !== 'TODAS' && i.categoria !== categoria) return false;
      if (q && !i.modelo.toLowerCase().includes(q)) return false;
      return true;
    });
  }, [items, marca, categoria, busqueda]);

  return (
    <div className="cmp-page">
      <div className="cmp-wrap">
        <div className="cmp-header">
          <h1 className="cmp-titulo">Catálogo de Motos</h1>
          <p className="cmp-subtitulo">Conoce los modelos disponibles y pregunta por precios y planes con tu asesor</p>
        </div>

        <div className="cmp-filtros">
          <select className="cmp-filtro-select" value={marca} onChange={e => setMarca(e.target.value)}>
            <option value="TODAS">Todas las marcas</option>
            <option value="Vento">Vento</option>
            <option value="Italika">Italika</option>
            <option value="Montier">Montier</option>
            <option value="Bajaj">Bajaj</option>
            <option value="Suzuki">Suzuki</option>
          </select>
          <select className="cmp-filtro-select" value={categoria} onChange={e => setCategoria(e.target.value)}>
            {categorias.map(c => (
              <option key={c} value={c}>{c === 'TODAS' ? 'Todas las categorías' : c}</option>
            ))}
          </select>
          <input
            type="text"
            className="cmp-filtro-input"
            placeholder="Buscar modelo..."
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
          />
        </div>

        {loading && <p className="cmp-msg">Cargando...</p>}
        {error   && <p className="cmp-msg cmp-msg--error">{error}</p>}

        {!loading && !error && lista.length === 0 && (
          <p className="cmp-msg">No hay modelos que coincidan con el filtro.</p>
        )}

        {!loading && !error && lista.length > 0 && (
          <div className="cmp-grid">
            {lista.map(item => (
              <div key={item.id} className="cmp-card">
                <div className="cmp-card-img-wrap">
                  {item.url_imagen
                    ? <img src={item.url_imagen} alt={item.modelo} className="cmp-card-img" loading="lazy" />
                    : <div className="cmp-card-img-placeholder">Sin imagen</div>}
                  <span className={`cmp-badge cmp-badge--${item.marca.toLowerCase()}`}>{item.marca}</span>
                </div>
                <div className="cmp-card-body">
                  {item.categoria && <span className="cmp-card-categoria">{item.categoria}</span>}
                  <h3 className="cmp-card-modelo">{item.modelo}</h3>
                  <span className="cmp-card-info">Pregunta por esta moto con tu asesor</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
